import { getInitParams } from 'utils';

const getBasePathTracking = (customSplunkUrl = null) => {
  const {
    REACT_APP_SPLUNK_URL,
    REACT_APP_SPLUNK_URL_TIENDEO,
    REACT_APP_SPLUNK_PASSWORD,
    REACT_APP_SPLUNK_PASSWORD_TIENDEO,
  } = process.env;
  const { language } = getInitParams();

  let trackingUrl = customSplunkUrl;
  let password = '';
  if (!trackingUrl) {
    if (['es_es', 'pt_pt'].includes(language)) {
      trackingUrl = REACT_APP_SPLUNK_URL_TIENDEO;
      password = REACT_APP_SPLUNK_PASSWORD_TIENDEO;
    } else {
      trackingUrl = REACT_APP_SPLUNK_URL;
      password = REACT_APP_SPLUNK_PASSWORD;
    }
  }

  return { trackingUrl, password };
};

export { getBasePathTracking };
